import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  maxWidth: {
    width: '100%'
  },
  forceNewLine: {
    flexBasis: '100%'
  },
  fieldDescription: {
    marginTop: 4,
    fontSize: '0.8rem',
    lineHeight: 1.4,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  // textField: {
  //   marginRight: theme.spacing(1),
  //   flex: 1,
  // },
  link: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.blue_300.main,
    margin: '20px 0 0 8px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  iconButton: {
    color: theme.palette.blue_300.main,
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&.Mui-disabled': {
      opacity: 0.3
    }
  },

}))
